// extracted by mini-css-extract-plugin
export default {"cls1":"Pagination-IconSkeleton_cls1__A0TJV","cls2":"Pagination-IconSkeleton_cls2__kQPMB Pagination-IconSkeleton_cls1__A0TJV"};